import React from 'react';
import {
  InfoContainer,
  InfoWrapper,
  InfoRow,
  Column1,
  Column2,
  TextWrapper,
  TopLine,
  Heading,
  Subtitle,
  BtnWrap,
  ImgWrap,
  Img,
  BtnLink
} from './AboutElements';
import lib from '../../images/lib_2.jpg';
const AboutSection = () => {
  return (
    <>
      <InfoContainer $lightBg={true}>
        <InfoWrapper>
          <InfoRow $imgStart={false}>
            <Column1>
              <TextWrapper>
                <TopLine>Who We Are</TopLine>
                <Heading $lightText={false}>New parents on a little mission to share some joy and gratitude</Heading>
                <Subtitle $darkText={true}>How do we actually make a difference in the world? Honestly, we're still figuring it out. But giving everyone we can a free book? That feels like a pretty good start. Who knows—maybe we'll make some memories. We don't really expect this endeavor to be profitable, but we do put a lot of effort into it—so if it ends up being that way, that is great too.</Subtitle>
              </TextWrapper>
            </Column1>
            <Column2>
              <ImgWrap>
                <Img src={lib} alt={'Family'} />
              </ImgWrap>
            </Column2>
          </InfoRow>
        </InfoWrapper>
      </InfoContainer>
    </>
  );
};

export default AboutSection;
